import  groq from 'groq';

export const termsAndConditionsQuery = groq`
  *[_type == "termsAndConditions" && isActive == true][0] {
    _id,
    title,
    description,
    icon {
      asset->{
        _id,
        url,
        metadata {
          dimensions {
            width,
            height
          }
        }
      },
      alt
    },
    isActive
  }
`;

export const localizedTermsAndConditionsQuery = (locale: string) => groq`
  *[_type == "termsAndConditions" && isActive == true][0] {
    _id,
    title,
    description,
    icon {
      asset->{
        _id,
        url,
        metadata {
          dimensions {
            width,
            height
          }
        }
      },
      alt
    },
    isActive
  }
`;
